import { createApp } from 'vue'
import App from './App.vue'
require('@/assets/main.scss')
createApp(App).mount('#app')
